<template>
  <div class="articleDetail">
    <div class="title">
      <img
        v-if="articleInfo.is_top === 1"
        class="show_top"
        src="../../../assets/images/show_top.png"
        alt=""
      />{{ articleInfo.title }}
    </div>
    <div class="list acea-row row-middle row-between">
      <div class="item">
        {{ articleInfo.add_date }}
        <span class="visit">
          {{ articleInfo.visit }}<span class="read">阅读</span>
        </span>
      </div>
      <div class="item">作者:{{ articleInfo.author }}</div>
    </div>
    <div class="slider-banner swiper">
      <swiper class="swiper-wrapper" :options="RecommendSwiper">
        <swiperSlide
          class="swiper-slide"
          v-for="(item, index) in articleInfo.image_input"
          :key="index"
        >
          <img :src="item" class="slide-image" />
        </swiperSlide>
      </swiper>
      <!-- <div class="swiper-pagination"></div> -->
    </div>
    <div class="conter" v-html="articleInfo.content"></div>
    <!-- <div class="picTxt acea-row row-between-wrapper" v-if="storeInfo.id">
      <div class="pictrue"><img :src="storeInfo.image" /></div>
      <div class="text">
        <div class="name line1">{{ storeInfo.store_name }}</div>
        <div class="money c-brand">
          ￥<span class="num">{{ storeInfo.ot_price }}</span>
        </div>
        <div class="y_money">￥{{ storeInfo.price }}</div>
      </div>
      <router-link :to="{ path: '/detail/' + storeInfo.id }">
        <div class="label"><span class="span">查看商品</span></div>
      </router-link>
    </div> -->
    <div class="bnt bgc-brand" v-if="isWeixin" @click="setShareInfoStatus">
      和好友一起分享
    </div>
    <ShareInfo
      v-on:setShareInfoStatus="setShareInfoStatus"
      :shareInfoStatus="shareInfoStatus"
    ></ShareInfo>
  </div>
</template>
<script>
import { getArticleDetails } from "@api/public";
import ShareInfo from "@components/ShareInfo";
import { isWeixin } from "@utils/index";
import { openShareAll } from "@libs/wechat";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "@assets/css/swiper.min.css";

export default {
  name: "NewsDetail",
  components: {
    ShareInfo,
    swiper,
    swiperSlide
  },
  props: {},
  data: function() {
    return {
      articleInfo: {},
      storeInfo: {},
      shareInfoStatus: false,
      isWeixin: isWeixin(),
      RecommendSwiper: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      }
    };
  },
  watch: {
    $route(to) {
      if (to.name === "NewsDetail") this.articleDetails();
    }
  },
  mounted: function() {
    this.articleDetails();
  },
  methods: {
    updateTitle() {
      document.title = this.articleInfo.title || this.$route.meta.title;
    },
    articleDetails: function() {
      let that = this,
        id = this.$route.params.id;
      getArticleDetails(id).then(res => {
        res.data.add_date = res.data.add_time
          ? res.data.add_time.split(" ")[0]
          : `''`;
        that.articleInfo = res.data;
        that.storeInfo = res.data.store_info || {};
        that.updateTitle();
        if (that.isWeixin) that.share();
      });
    },
    setShareInfoStatus: function() {
      this.shareInfoStatus = !this.shareInfoStatus;
    },
    share: function() {
      openShareAll({
        desc: this.articleInfo.synopsis,
        title: this.articleInfo.title,
        link: location.href,
        imgUrl: this.articleInfo.image_input.length
          ? this.articleInfo.image_input[0]
          : ""
      });
    }
  }
};
</script>
<style scoped>
.slider-banner {
  margin: 0 0.3rem;
}
.visit {
  margin-left: 0.28rem;
}
.read {
  margin-left: 0.04rem;
}
.show_top {
  width: 0.6rem;
  height: 0.34rem;
  vertical-align: sub;
  margin-right: 0.04rem;
}
.articleDetail .swiper-slide {
  width: 6.9rem !important;
}
.articleDetail .bnt {
  color: #fff;
  font-size: 30rpx;
  width: 6.9rem;
  height: 0.9rem;
  border-radius: 0.46rem;
  margin: 0.48rem auto 0.2rem auto;
  text-align: center;
  line-height: 0.9rem;

}
</style>
